<template>
    <div id="page">

        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>
                    {{pageTitle}}
                    <button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="card card-style mb-2">
                <div class="content mb-0">
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check brand-color"></i>
                        <span class="color-highlight input-style-1-active input-style-1-inactive" :class="{'input-style-1-active' : project.title!==null}">کد</span>
                        <input class="form-control ltr text-l" readonly type="text" id="lblcode" v-model="project.code" @input="v$.project.code.$touch()" :class="{invalid:v$.project.code.$error}">
                        <p class="text-danger" v-if="v$.project.code.required.$invalid && v$.project.code.$dirty">لطفا کد را وارد کنید.</p>
                    </div>
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check brand-color"></i>
                        <span class="color-highlight input-style-1-active input-style-1-inactive" :class="{'input-style-1-active' : project.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="project.title" @input="v$.project.title.$touch()" :class="{invalid:v$.project.title.$error}">
                        <p class="text-danger" v-if="v$.project.title.required.$invalid && v$.project.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check brand-color"></i>
                        <span class="color-highlight input-style-1-active input-style-1-inactive">سطح پروژه</span>
                        <input class="form-control" readonly id="lblLevelTitle" type="text" v-model="project.levelTitle">
                    </div>
                    <div class="w-100  mx-0 mb-3">
                        <v-select :disabled="isMinVersion || isReadOnlyType" dir="rtl" v-model="project.projectTypeId" label="title" placeholder="نوع پروژه" :options="GetProjectTypeList" :reduce="p => p.projectTypeId">
                            <template v-slot="option">
                                <div class="d-center">
                                    <span>{{option.title}}</span>
                                </div>
                            </template>
                        </v-select>
                        <p class="text-danger" v-if="v$.project.projectTypeId.required.$invalid && v$.project.projectTypeId.$dirty">لطفا نوع پروژه را وارد کنید.</p>
                    </div>
                    <div class="mx-0 mb-3">
                        <div class="input-style input-style-2 has-icon input-required mb-0">
                            <i class="input-icon fa fa-calendar brand-color"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : project.startDate!==null}">از تاریخ</span>
                            <input class="text-left" type="text" v-model="project.startDate" id="endDf" />
                        </div>
                        <date-picker type="date" v-model="project.startDate" format="jYYYY/jMM/jDD" element="endDf" />
                    </div>

                    <div class="mx-0 mb-3">
                        <div class="input-style input-style-2 has-icon input-required mb-0">
                            <i class="input-icon fa fa-calendar brand-color"></i>
                            <span class="color-highlight" :class="{'input-style-1-active' : project.endDate!==null}">تا تاریخ</span>
                            <input class="text-left" type="text" v-model="project.endDate" id="endDT" />
                        </div>
                        <date-picker type="date" v-model="project.endDate" format="jYYYY/jMM/jDD" element="endDT" />
                    </div>
                    <div class="card mx-0 mb-3">
                        <textarea v-model="project.description" class="form-control line-height-m text-justify rounded-sm mb-3" rows="3" style="height:200px" placeholder="توضیحات"></textarea>
                        <button class="btn btn-link speechToTextBtn" @pointerdown="startR"
                                @pointerup="stopR">
                            <span :class="btnRecord">
                                <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                            </span>
                            <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                        </button>
                    </div>
                    <button type="button" :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="AddOrEditProject">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading || pageLoaded" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
        <Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
        <Help-Menu title="ثبت و مدیریت پروژه ها" keyEn="project" v-if="isKarnegasht==true"></Help-Menu>
    </div>
</template>

<script>
    import useVuelidate from '@vuelidate/core';
    import {
        required
    } from "@vuelidate/validators";
    import VueSimpleAlert from "vue3-simple-alert";
    import HelpMenu from '../Components/HelpMenu.vue';
    import DatePicker from 'vue3-persian-datetime-picker';
    //import AttList from '../Components/AttList.vue';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
    export default {
        components: {
            DatePicker,
            "Help-Menu": HelpMenu,
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                pageTitle: "افزودن پروژه",
                showType: false,
                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",
                pageLoaded: false,
                isReadOnlyType: false,
                project: {
                    personId: null,
                    title: "",
                    code: "",
                    localDomains: [],
                    projectId: 0,
                    subQuantity: 0,
                    tempId: 0,
                    parentId: 0,
                    levelId: 1,
                    displayLevelId: 1,
                    localUserIds: "",
                    workGroupIds: "",
                    startDate: null,
                    endDate: null,
                    attJson: "",
                    levelTitle: null,
                    allUserAccess: true,
                    projectTypeId: null,
                    projectTypeTitle: "",
                    description: ""
                },
            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            GetProjectTypeList() {
                return this.$store.getters.GetProjectTypeList;
            },
        },
        created() {
            if (this.$route.params.projectId != null && this.$route.params.projectId != 0) {
                this.pageTitle = "ویرایش پروژه";
                this.GetProjectItem(this.$route.params.projectId);

            } else if (this.$route.params.parentId != null && this.$route.params.parentId != 0) {
                this.pageTitle = "افزودن پروژه زیر مجموعه";
                this.project.parentId = this.$route.params.parentId;
                this.GetProjectItem(this.$route.params.parentId, true);
                this.GetCode();
            } else {
                if (this.isMinVersion) {
                    this.showErrorMessage("امکان تعریف پروژه در این سطح وجود ندارد ");
                    setTimeout(function () { window.location.href = "/ProjectList"; }, 1500);
                }
                this.pageTitle = "افزودن پروژه";
                this.$store.dispatch("GetProjectTypeListFromServer", {
                    isAll: true
                });
                this.GetCode();
                this.GetProjectLevelItem(this.project.levelId);
            }
        },
        validations: {
            project: {
                title: {
                    required,
                },
                code: {
                    required,
                },
                projectTypeId: {
                    required,
                },
            }
        },
        methods: {
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                }
            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                }
            },
            GetProjectItem(id, isParent = false) {
                this.pageLoaded = true;
                this.$http.get("Project/GetProjectItem", {
                    params: {
                        id: id
                    }
                }).then(data => {
                    if (isParent) {
                        data.data.code = "";
                        data.data.title = "";
                        data.data.title = "";
                        data.data.startDate = null;
                        data.data.endDate = null;
                        data.data.subQuantity = 0;
                        data.data.description = "";
                        data.data.levelId = data.data.levelId + 1;
                        data.data.displayLevelId = data.data.levelId;
                        data.data.parentId = data.data.projectId;
                        data.data.projectId = 0;
                        this.isReadOnlyType = true;
                    } else {
                        if (data.data.parentId != 0) {
                            this.isReadOnlyType = true;
                        }
                    }
                    this.project = data.data;
                    if (isParent)
                        this.GetCode();
                    this.pageLoaded = false;
                    this.$store.dispatch("GetProjectTypeListFromServer", {
                        isAll: true,
                        typeId: this.project.projectTypeId
                    });
                    this.GetProjectLevelItem(this.project.levelId);
                });


            },
            GetCode() {
                this.$http.get("Project/GetMaxProjectCode", {
                    params: {
                        levelId: this.project.levelId,
                        parentid: this.project.parentId
                    }
                }).then(data => {
                    this.project.code = data.data.toString();
                    document.getElementById('lblcode').setAttribute('maxlength', this.project.code.length);
                });

            },
            GetProjectLevelItem(levelId) {
                this.$http.get("Project/GetProjectLevelItem", {
                    params: {
                        id: this.project.levelId,
                    }
                }).then(data => {
                    if (!data.data.isSuccess) {
                        this.showErrorMessage("امکان تعریف زیرمجموعه برای این پروژه وجود ندارد ");
                        setTimeout(function () { window.location.href = "/ProjectList"; }, 1500);
                    } else {
                        this.project.levelTitle = data.data.obj.title;
                    }
                });
            },
            AddOrEditProject() {
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.$store.dispatch("ProjectAddOrEdit", this.project
                    );
                }
            },
            ShowAttList() {
                var btnShowModal = document.getElementById("btnattListModal");
                btnShowModal.click();
                document.getElementsByClassName('menu-hider')[0].click();
            }
        },
        mounted() {
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.timer.description == null || this.timer.description == "null")
                        this.timer.description = "";
                    if (rest != null && rest != '')
                        this.timer.description = this.timer.description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
            }

            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    };
</script>
